// extracted by mini-css-extract-plugin
module.exports = {"Card":"ColorCard_Card__1FvbI"};